import * as Actions from "../actions";

const initialState = {
  success: false,
  isRegisterLoading: false,
  errorRegister: null,
  data: null,
};

const register = function (state = initialState, action) {
  switch (action.type) {
    case Actions.REGISTER_START: {
      return {
        ...initialState,
        isRegisterLoading: true,
      };
    }
    case Actions.REGISTER_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isRegisterLoading: false,
        data: action.payload.data,
      };
    }
    case Actions.REGISTER_ERROR: {
      return {
        success: false,
        isRegisterLoading: false,
        errorRegister: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default register;
